import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lg:container lg:mx-auto pt-10 md:pt-12" }
const _hoisted_2 = { class: "px-4 lg:px-0" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mb-16" }, null, -1)
const _hoisted_5 = { class: "px-4 lg:px-0" }
const _hoisted_6 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PoolsTable = _resolveComponent("PoolsTable")!
  const _component_TokenSearchInput = _resolveComponent("TokenSearchInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isWalletReady)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('myV2Investments')), 1)
          ]),
          _createVNode(_component_PoolsTable, {
            isLoading: _ctx.isLoadingUserPools,
            data: _ctx.userPools,
            noPoolsLabel: _ctx.$t('noInvestments'),
            showPoolShares: "",
            selectedTokens: _ctx.selectedTokens,
            class: "mb-8"
          }, null, 8, ["isLoading", "data", "noPoolsLabel", "selectedTokens"]),
          _hoisted_4
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('investmentPools')), 1),
      _createVNode(_component_TokenSearchInput, {
        modelValue: _ctx.selectedTokens,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedTokens = $event)),
        loading: _ctx.isLoadingPools,
        onAdd: _ctx.addSelectedToken,
        onRemove: _ctx.removeSelectedToken
      }, null, 8, ["modelValue", "loading", "onAdd", "onRemove"])
    ]),
    _createVNode(_component_PoolsTable, {
      isLoading: _ctx.isLoadingPools,
      data: _ctx.filteredPools,
      noPoolsLabel: _ctx.$t('noPoolsFound'),
      isPaginated: _ctx.poolsHasNextPage,
      isLoadingMore: _ctx.poolsIsFetchingNextPage,
      onLoadMore: _ctx.loadMorePools,
      selectedTokens: _ctx.selectedTokens,
      class: "mb-8"
    }, null, 8, ["isLoading", "data", "noPoolsLabel", "isPaginated", "isLoadingMore", "onLoadMore", "selectedTokens"])
  ]))
}